import { StyleSheet, View } from 'react-native';
import { Text } from '@rneui/themed';
import { useTranslation } from 'react-i18next';

const Goal = ({ goalText }) => {
  const { t } = useTranslation();
  return (
    <View>
      <Text>{goalText}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  goalView: {
    flexDirection: 'row',
  },
});

export default Goal;
